<template>
  <div class="mx-auto">
    <b-row >
      <b-col xxs="12">
        <div class="row my-5">
          <div class="col-lg-8">
            <h1 class="m-0 p-0 font-weight-boldest mega-text">
              Contact Us
            </h1>
            <h6 class="font-weight-bold">
              Get in touch with us if you have an issue.
            </h6>
          </div>
        </div>

        <div class="row no-gutters bg-white mb-5">
        
          <div class="col-12">
            <b-list-group flush>
              <b-list-group-item style="background: transparent">
               <br> <i class="lni lni-envelope font-size-26 text-primary"></i> <br><br>
                <a href="mailto:zaid@rapidsoft.co.za" class="text-body"
                  >zaid@rapidsoft.co.za</a
                ></b-list-group-item
              >
             
                
            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
    };
  },
};
</script>
